import { Box, BoxProps, TextNew, TextNewProps } from '@jfs/ui-new'
import { Colors } from '../../utils'

export interface StatusIndicatorProps {
  type:
    | 'active'
    | 'scheduled'
    | 'completed'
    | 'inactive'
    | 'terminated'
    | 'deleted'
    | 'pending'
    | 'error'
    | 'pending for approval'
    | 'rejected'
    | 'blocked'
    | 'suspend'
    | 'hot_merchant'
    | 'closed_by_merchant'
    | 'closed_by_ops_team'
}

const StatusIndicator = ({ type }: StatusIndicatorProps) => {
  console.log('StatusIndicator type', type)
  const label =
    type === 'active'
      ? 'Active'
      : type === 'scheduled'
      ? 'Scheduled'
      : type === 'terminated'
      ? 'Terminated'
      : type === 'deleted'
      ? 'Deleted'
      : type === 'pending'
      ? 'Pending'
      : type === 'error'
      ? 'Error'
      : type === 'completed'
      ? 'Completed'
      : type === 'inactive'
      ? 'In Active'
      : type === 'rejected'
      ? 'Rejected'
      : type === 'pending for approval'
      ? 'Pending For Approval'
      : type === 'blocked'
      ? 'Blocked'
      : type === 'closed_by_ops_team'
      ? 'Closed'
      : type === 'suspend'
      ? 'Suspend'
      : type === 'hot_merchant'
      ? 'Hot Merchant'
      : type === 'closed_by_merchant'
      ? 'Closed'
      : 'N/A'

  return (
    <Box {...styles.container(type)}>
      <TextNew {...styles.labelStyle(type)}>{label}</TextNew>
    </Box>
  )
}

const styles = {
  container: (type: string) =>
    ({
      width: type === 'active' ? '48px' : type === 'pending for approval' ? '140px' : '76px',
      height: type === 'active' ? '20px' : '24px',
      justify: 'center',
      align: 'center',
      borderRadius: type === 'active' ? '4px' : '12px',
      bg:
        type === 'active' || type === 'completed'
          ? Colors.GREEN_BG_C
          : type === 'scheduled' ||
            type === 'inactive' ||
            type === 'pending' ||
            type === 'pending for approval' ||
            type === 'suspend' ||
            type === 'hot_merchant'
          ? Colors.ORANGE_BG_C
          : type === 'terminated' ||
            type === 'deleted' ||
            type === 'error' ||
            type === 'rejected' ||
            type === 'blocked' ||
            type === 'closed_by_ops_team' ||
            type === 'closed_by_merchant'
          ? Colors.RED_BG_C
          : 'BRAND_COLOR_GRAY_3',
    } as BoxProps),
  labelStyle: (type: string) =>
    ({
      type: 'body12',
      fontWeight: 'MEDIUM',
      color:
        type === 'active'
          ? Colors.GREEN_C
          : type === 'completed'
          ? 'BRAND_COLOR_GRAY_1'
          : type === 'terminated' ||
            type === 'error' ||
            type === 'rejected' ||
            type === 'blocked' ||
            type === 'closed_by_ops_team' ||
            type === 'closed_by_merchant'
          ? Colors.RED_C
          : type === 'pending' ||
            type === 'pending for approval' ||
            type === 'inactive' ||
            type === 'suspend' ||
            type === 'hot_merchant'
          ? Colors.ORANGE_C
          : 'BRAND_PRIMARY_WHITE',
    } as TextNewProps),
}

export { StatusIndicator }
